module.exports = __webpack_public_path__ + "static/media/3Transparency.889de8cf.svg";